import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { EMPTY, Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class AppVersionService {
	constructor(private http: HttpClient) { }

	public getAppBackendVersion(): Observable<string> {
		return this.http
			.get('rest/common/artifact', { responseType: 'text' })
			.pipe(catchError(() => EMPTY));
	}
}
